import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { PieChart } from 'react-minimal-pie-chart';
import { usePDF } from 'react-to-pdf';

const defaultLabelStyle = {
  fontSize: '5px',
  fontFamily: 'sans-serif',
};

const RiskProfileList = ({ config, onSelectProfile, selectedProfile }) => {
  const [profiles, setProfiles] = useState([]);

  useEffect(() => {
    axios.get(`${config.PY_API_URL}member/risk-profile?user_id=${config.user_id}`)
      .then(response => {
        setProfiles(response.data.data.profiles);
      })
      .catch(error => console.error('Error fetching profiles:', error));
  }, []);

  return (
    <div>
      <h1>My Risk Profiles</h1>
      <div className='risk-profile-container'>
        {profiles.map(profile => (
          <div 
            className={'risk-profile-card' + (selectedProfile && selectedProfile.id === profile.id ? ' selected_profile' : '')}
            key={profile.id} 
            onClick={() => onSelectProfile(profile)}
          >
            {/* <h2>{profile.profile_name}</h2> */}
            <p><strong>User Name:</strong> {profile.user_name}</p>
            <p><strong>Date of Birth:</strong> {profile.dob}</p>
            <p><strong>Phone:</strong> {profile.phone}</p>
            <p><strong>Occupation:</strong> {profile.occupation}</p>
            <p><strong>Total Score:</strong> {profile.total_score}</p>
          </div>
        ))}
      </div>
    </div>
  );
};


const RiskProfileForm = ({ config, profile = {}, onSave, onUpdate, quest = [] }) => {
  const [formData, setFormData] = useState({
    mm_user_id: profile.mm_user_id || '',
    profile_name: profile.profile_name || '',
    user_name: profile.user_name || '',
    dob: profile.dob || '',
    phone: profile.phone || '',
    occupation: profile.occupation || '',
    total_score: profile.total_score || 0,
    risk_tolerance_score: profile.risk_tolerance_score || 0,
    risk_capacity_score: profile.risk_capacity_score || 0,
    status: profile.status || '',
    questions: profile.questions || quest || [],
  });
  
  const [questions, setQuestions] = useState(quest || []);

  useEffect(() => {
    console.log("profile.user_name", profile.user_name)
    
    setQuestions(quest);
    setFormData({
      ...formData,
      user_name: profile.user_name,
      dob: profile.dob,
      phone: profile.phone,
      occupation: profile.occupation,
      total_score: profile.total_score
    });
    console.log("formData.occupation", formData.occupation);
  }, [quest, profile.dob, profile.user_name, profile.phone, profile.occupation, profile.total_score]);

  useEffect(() => {
    setFormData({
      mm_user_id: profile.mm_user_id || '',
      profile_name: profile.profile_name || '',
      user_name: profile.user_name || '',
      dob: profile.dob || '',
      phone: profile.phone || '',
      occupation: profile.occupation || '',
      total_score: profile.total_score || 0,
      risk_tolerance_score: profile.risk_tolerance_score || 0,
      risk_capacity_score: profile.risk_capacity_score || 0,
      status: profile.status || '',
      questions: profile.questions || quest || [],
    });
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    console.log("formData.occupation 2", formData.name);
    console.log("formData.occupation 2", formData.occupation);
  };

  const handleOptionChange = (questionIndex, optionIndex) => {
    const newQuestions = questions.map((q, index) => {
      if (index === questionIndex) {
        return {
          ...q,
          selected_option: q.options[optionIndex].option_text,
          selected_option_score: q.options[optionIndex].score
        };
      }
      return q;
    });
    console.log("questions", newQuestions);
    let score = 0;
    for (let q of newQuestions) {
      score = score + q.selected_option_score
    }
    setQuestions(newQuestions);
    setFormData({ ...formData, 
      questions: newQuestions,
      total_score: score
     });
  };

  const handleSubmit = () => {
    let apiRequest = formData;
    if (profile.id) {
      apiRequest.id = profile.id;
      onUpdate(apiRequest);
    } else {
      apiRequest.mm_user_id = config.user_id;
      console.log("handleSubmit", apiRequest, questions);
      onSave(apiRequest);
    }
  };


  // const viewScore = () => {
  //   let score = 0;
  //   for (let q of questions) {
  //     score = score + q.selected_option_score
  //   }
  //   setFormData({ ...formData, totalScore: score });
  // };

  return (
    <div>
      <h1>{profile.id ? 'Edit' : 'Create'} Risk Profile</h1>
      <div style={{ float: "left", marginRight: 10, width: "23%" }}>
        <label>
          Name:
          <input 
            type="text" 
            name="user_name" 
            value={formData.user_name} 
            onChange={handleInputChange} 
          />
        </label>
      </div>
      <div style={{ float: "left", marginRight: 10, width: "23%" }}>
        <label>
          Date of Birth:
          <input 
            type="date" 
            name="dob" 
            value={formData.dob} 
            onChange={handleInputChange} 
          />
        </label>
      </div>
      <div style={{ float: "left", marginRight: 10, width: "23%" }}>
        <label>
          Phone No.:
          <input 
            type="tel" 
            name="phone" 
            value={formData.phone} 
            onChange={handleInputChange} 
          />
        </label>
      </div>
      <div style={{ float: "left", marginRight: 10, width: "23%" }}>
        <label>
          Occupation:
          <select 
            name="occupation" 
            value={formData.occupation} 
            // onChange={handleInputChange} 
          >
            <option value="Service">Service</option>
            <option value="Business">Business/Self-employed</option>
            <option value="Student">Student/Homemaker/Retired</option>
          </select>
        </label>
      </div>

      <div style={{ width: "100%", clear: "both", paddingTop: "35px" }}>
        {questions.length && questions.map((q, index) => (
          <div key={index} className="question-block">
            <p>{q.question_text}</p>
            {q.options.map((option, idx) => (
              <div key={idx} className="option">
                <input
                  type="radio"
                  id={`q${index}o${idx}`}
                  name={`q${index}`}
                  value={option.score}
                  checked={q.selected_option === option.option_text}
                  onChange={() => handleOptionChange(index, idx)}
                />
                <label htmlFor={`q${index}o${idx}`}>{option.option_text}</label>
              </div>
            ))}
          </div>
        ))}
      </div>

      <div style={{ width: "100%", clear: "both", paddingTop: "35px" }}>
        
      </div>

        <div style={{ paddingLeft: "12pt", textIndent: "0pt", textAlign: "left", width: "100%" }}>
          This questionnaire is designed to help you in identifying an investment approach that could generally suit you. The answers define your capacity/ tolerance towards the level of risk you may accept on your investments. It attempts to measure your appetite to market volatility, weigh the importance of your financial goals, and uncover your personal investment preferences. It has two parts to identify/ evaluate your
        </div>
        <ol>
          <li data-list-text="1">
            <p style={{ paddingLeft: "21pt", textIndent: "-9pt", textAlign: "left" }}>
              Risk Capacity, and 2) Risk Tolerance.
            </p>
          </li>
        </ol>
        <p style={{ textIndent: "0pt", textAlign: "left" }}>
          <br />
        </p>
        <p style={{ paddingLeft: "12pt", textIndent: "0pt", textAlign: "justify" }}>
          Risk Capacity: <span style={{ color: "#000" }}>It is the level of risk that the investor may take in order to achieve financial goals. It is largely dependent on the investor’s age, profession, income, and financial goals. For example, if you need a retirement corpus of around ₹50 lakhs after 10 years, with current savings of ₹5 lakhs and monthly additions of ₹20,000, you will need a portfolio return of approximately 10% per year. This need comes with a certain level of risk, which is your risk capacity. In other words, it is the amount of ‘risk you NEED to take to reach your financial objectives’.</span>
        </p>
        <p style={{ textIndent: "0pt", textAlign: "left" }}>
          <br />
        </p>


        {/* <div className="navigation-buttons view-score-btn">
          <button type='button' onClick={viewScore}>
            View Score
          </button>
        </div> */}

        <div>
          <h2>Total Scores</h2>
          <p>Risk Capacity Score: {formData.risk_capacity_score}</p>
          <p>Risk Tolerance Score: {formData.risk_tolerance_score}</p>
          <p>Total Score: {formData.total_score}</p>
        </div>

      <div className="navigation-buttons view-score-btn">
        <button type='button' onClick={handleSubmit}>
          {profile.id ? 'Update' : 'Save'} Profile
        </button>
      </div>
    </div>
  );
};


const RiskProfilerForm = ({config}) => {
  const { toPDF, targetRef } = usePDF({filename: 'profile.pdf'});
  const [selectedProfile, setSelectedProfile] = useState(null);


  const [formData, setFormData] = useState({
    name: '',
    dateOfBirth: '',
    phone: '',
    occupation: '',
    riskCapacityScore: 0,
    riskToleranceScore: 0,
    totalScore: 0,
  });

  const [responses, setResponses] = useState(Array(12).fill(0));
  const [totalScore, setTotalScore] = useState(0);
  const [questions, setQuestions] = useState([]);


  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
    console.log("formData.occupation 1", formData.occupation);
  };

  const handleAddNewProfile = () => {
    setSelectedProfile(null); // Clear selectedProfile to open a blank form
  };

  const handleSelectProfile = profile => {
    setSelectedProfile(profile);
    console.log("selectedProfile", selectedProfile);
  };

  const handleSaveProfile = profileData => {
    axios.post(`${config.PY_API_URL}member/risk-profile`, profileData)
      .then(response => {
        alert('Profile saved successfully!');
        setSelectedProfile(null);
      })
      .catch(error => console.error('Error saving profile:', error));
  };

  const handleUpdateProfile = profileData => {
    axios.put(`${config.PY_API_URL}member/risk-profile/${profileData.id}`, profileData)
      .then(response => {
        alert('Profile updated successfully!');
        setSelectedProfile(null);
      })
      .catch(error => console.error('Error updating profile:', error));
  };

  const handleOptionChange = (questionIndex, optionIndex) => {
    const question = questions[questionIndex];
    const score = question.options[optionIndex].score;
    setFormData({ ...formData, [questionIndex]: score });
  };

  const handleSubmit = () => {
    const score = Object.values(formData).reduce((acc, curr) => +acc + +curr, 0);
    setTotalScore(score);
  };

  useEffect(() => {
    const fetchQuestions = async () => {
      try {
        const response = await axios.get(`${config.PY_API_URL}member/risk-profile/questions`);
        let questions = response.data.data.questions;
        setQuestions(questions);
        setResponses(Array(response.data.data.questions.length).fill(0))
      } catch (error) {
        console.error('Error fetching questions:', error);
      }
    };

    fetchQuestions();
  }, ['questions']);

  return (
    <>

      <div className="elementor-widget-container mm-bred">
          <ul className="elementor-icon-list-items elementor-inline-items">
          <li className="elementor-icon-list-item elementor-inline-item bred-item">
            <a href={config.siteUrl}>
              <span className="elementor-icon-list-text">Home</span>
            </a>
          </li>
          <li className="elementor-icon-list-item elementor-inline-item bred-item">
            <a href={`${config.siteUrl}/submissions`}>
              <span className="elementor-icon-list-icon">
                <i aria-hidden="true" className="material zmdi zmdi-chevron-right" />						</span>
              <span className="elementor-icon-list-text">Profile</span>
            </a>
          </li>
          <li className="elementor-icon-list-item elementor-inline-item bred-item">
              <span className="elementor-icon-list-icon">
                <i aria-hidden="true" className="material zmdi zmdi-chevron-right" />						</span>
              <span className="elementor-icon-list-text">Risk Profile</span>
          </li>
        </ul>
      </div>

      <div className='mm-risk-profile-head'>
      {selectedProfile ? (
        <div style={{ marginBottom: '20px' }}>
          <button type="button" onClick={handleAddNewProfile}>
            Add New Profile
          </button>
        </div>
      ): (
        <></>
      )}
      </div>

      <RiskProfileList config={config} onSelectProfile={handleSelectProfile} selectedProfile={selectedProfile}/>

      {selectedProfile ? (
        <div className='download-btn-container'>
          <button onClick={() => toPDF()}>Download PDF</button>
        </div>
      ): (
        <></>
      )}
      <form className='risk-profile-container' onSubmit={handleSubmit} ref={targetRef}>

      {selectedProfile ? (
        <RiskProfileForm
          config={config}
          profile={selectedProfile}
          quest={selectedProfile?.questions || questions}
          onSave={handleSaveProfile}
          onUpdate={handleUpdateProfile}
        />
      ) : (
        <RiskProfileForm 
          config={config} 
          quest={selectedProfile?.questions || questions}   
          onSave={handleSaveProfile} 
        />
      )}

        {/* <h1>Client Risk Profiler (Individuals)</h1>
        <div style={{ float: "left", marginRight: 30 }}>
          <label>
            Name:
            <input type="text" name="name" value={formData.name} onChange={handleInputChange} />
          </label>
        </div>
        <div style={{ float: "left", marginRight: 30 }}>
          <label>
            Date of Birth:
            <input type="date" name="dateOfBirth" value={formData.dateOfBirth} onChange={handleInputChange} />
          </label>
        </div>
        <div style={{ float: "left", marginRight: 30 }}>
          <label>
            Phone No.:
            <input type="tel" name="phone" value={formData.phone} onChange={handleInputChange} />
          </label>
        </div>
        <div style={{ float: "left", marginRight: 30 }}>
          <label>
            Occupation:
            <select name="occupation" value={formData.occupation} onChange={handleInputChange}>
              <option value="Service">Service</option>
              <option value="Business">Business/Self-employed</option>
              <option value="Student">Student/Homemaker/Retired</option>
            </select>
          </label>
        </div> */}

      {/* <div style={{ width: "100%", clear: "both", paddingTop: "35px" }}>
        
      </div>

        <div style={{ paddingLeft: "12pt", textIndent: "0pt", textAlign: "left", width: "100%" }}>
          This questionnaire is designed to help you in identifying an investment approach that could generally suit you. The answers define your capacity/ tolerance towards the level of risk you may accept on your investments. It attempts to measure your appetite to market volatility, weigh the importance of your financial goals, and uncover your personal investment preferences. It has two parts to identify/ evaluate your
        </div>
        <ol>
          <li data-list-text="1">
            <p style={{ paddingLeft: "21pt", textIndent: "-9pt", textAlign: "left" }}>
              Risk Capacity, and 2) Risk Tolerance.
            </p>
          </li>
        </ol>
        <p style={{ textIndent: "0pt", textAlign: "left" }}>
          <br />
        </p>
        <p style={{ paddingLeft: "12pt", textIndent: "0pt", textAlign: "justify" }}>
          Risk Capacity: <span style={{ color: "#000" }}>It is the level of risk that the investor may take in order to achieve financial goals. It is largely dependent on the investor’s age, profession, income, and financial goals. For example, if you need a retirement corpus of around ₹50 lakhs after 10 years, with current savings of ₹5 lakhs and monthly additions of ₹20,000, you will need a portfolio return of approximately 10% per year. This need comes with a certain level of risk, which is your risk capacity. In other words, it is the amount of ‘risk you NEED to take to reach your financial objectives’.</span>
        </p>
        <p style={{ textIndent: "0pt", textAlign: "left" }}>
          <br />
        </p> */}
        
        {/* {questions.length && questions.map((q, index) => (
          <div key={index} className="question-block">
            <p>{q.question_text}</p>
            {q.options.map((option, idx) => (
              <div key={idx} className="option">
                <input
                  type="radio"
                  id={`q${index}o${idx}`}
                  name={`q${index}`}
                  value={option.score}
                  onChange={() => handleOptionChange(index, idx)}
                />
                <label htmlFor={`q${index}o${idx}`}>{option.option_text}</label>
              </div>
            ))}
          </div>
        ))} */}

        {/* <div className="navigation-buttons view-score-btn">
          <button type='button' onClick={handleSubmit}>
            View Score
          </button>
        </div>

        <div>
          <h2>Total Scores</h2>
          <p>Risk Capacity Score: {formData.riskCapacityScore}</p>
          <p>Risk Tolerance Score: {formData.riskToleranceScore}</p>
          <p>Total Score: {totalScore}</p>
        </div> */}

        <>
    <p
      style={{
        paddingTop: "2pt",
        paddingLeft: "11pt",
        textIndent: "0pt",
        lineHeight: "109%",
        textAlign: "left"
      }}
    >
      Note: More often than not, investors have a lower risk tolerance for their
      required risk capacity. You may want to evaluate your investment objectives
      and constraints regularly and see them in alignment. We suggest that it
      should be done at least once in 3 years. In case, the risk capacity is
      higher than the tolerance level, investors should try to build their comfort
      level by enhancing knowledge on the markets and products. On the other hand,
      with a healthy tolerance for risk, a lower capacity suggests a moderate or
      low risk investment strategy.
    </p>
    <p
      className="s17"
      style={{
        paddingTop: "9pt",
        paddingLeft: "11pt",
        textIndent: "0pt",
        textAlign: "left"
      }}
    >
      The results revealed are for general consideration only and in no way
      constitute investment advice or a recommendation from the bank.
    </p>

    <div style={{ color: "#0097DB" }}>
      The results revealed are for general consideration only and in no way constitute investment advice or a recommendation from the bank.
    </div>

  <div>
    <label>
      <input
        type="radio"
        name="fresh_renew"
        value="0"
      />
      First time profiling
    </label>
    </div>

  <div>
    <label>
      <input
        type="radio"
        name="fresh_renew"
        value="1"
      />
      Profile Renewal
    </label>
    </div>

    <div style={{ color: "#0097DB" }}>
      What percentage of your total Net Assets** will you wish to invest through
      Money Marche?
    </div>

      <div>
    <label>
      <input
        type="radio"
        name="net_asset_pt"
        value="<25"
      />
      Less than 25%
    </label>
    </div>
    
    <div>
    <label>
      <input
        type="radio"
        name="net_asset_pt"
        value="25_to_50"
      />
      25% - 50%
    </label>
    </div>
    <div>
    <label>
      <input
        type="radio"
        name="net_asset_pt"
        value=">50"
      />
      Greater than 50%
    </label>
    </div>

    <p
      className="s14"
      style={{ paddingLeft: "11pt", textIndent: "0pt", textAlign: "left" }}
    >
      ** ”Total net assets” means: the amount of Assets available for Investment
      (including current income, savings, other existing investments, property or
      securities, with other banks or brokerages); less your Total Liabilities
      (i.e. rental, loans, mortgages and general living and educational expenses).
      Do not include in any calculation of assets or liabilities, the value of or
      debt owed on any self-occupied property or businesses you own.
    </p>
    <p style={{ textIndent: "0pt", textAlign: "left" }}>
      <br />
    </p>
    <table
      style={{ borderCollapse: "collapse", marginLeft: "373.1pt" }}
      cellSpacing={0}
    >
      {/* DATE INPUT TODO */}
    </table>
    <p
      className="s21"
      style={{
        paddingLeft: "11pt",
        textIndent: "0pt",
        lineHeight: "1pt",
        textAlign: "left"
      }}
    >
      {" "}
    </p>
    <p style={{ paddingLeft: "11pt", textIndent: "0pt", textAlign: "left" }}>
      Customer Signature: Place: Date:
    </p>
    <p style={{ textIndent: "0pt", textAlign: "left" }}>
      <br />
    </p>
    <p
      className="s14"
      style={{ paddingLeft: "11pt", textIndent: "0pt", textAlign: "justify" }}
    >
      Money Marche states:
    </p>
    <p
      className="s14"
      style={{ paddingLeft: "11pt", textIndent: "0pt", textAlign: "justify" }}
    >
      This risk profiler is intended for use by the customers as a tool for
      assessing the customer’s risk appetite/ capacity and risk taking ability/
      tolerance. Money Marche AG does not assure the correctness or accuracy of
      the risk assessment by means of the risk profiler. The risk profiler is not
      designed to assure or guarantee any returns or success of any particular
      investment
    </p>
    <p
      className="s14"
      style={{ paddingLeft: "11pt", textIndent: "0pt", textAlign: "justify" }}
    >
      alternative. Neither Money Marche AG nor any members of Money Marche group
      nor other respective directors, officers or employees shall be responsible
      for the contents of the risk profiler or the outcome of risk assessment.
      Investment in securities are subject to market risks. All decisions to sell
      or purchase units/ securities shall be on the basis of own personal judgment
      of the customer after consulting his/ her/ their own external investment
      consultant. Money Marche AG does not in any manner guarantee any returns on
      any of the investment products.
    </p>
    <p style={{ paddingTop: "6pt", textIndent: "0pt", textAlign: "left" }}>
      <br />
    </p>
    <p
      className="s22"
      style={{ paddingLeft: "12pt", textIndent: "0pt", textAlign: "left" }}
    >
      Risk  
      Capacity
      and
      Risk
      Tolerance
      Scoring
      
    </p>
    <p style={{ paddingTop: "2pt", textIndent: "0pt", textAlign: "left" }}>
      <br />
    </p>
    <table
      style={{ borderCollapse: "collapse", marginLeft: "12.25pt" }}
      cellSpacing={0}
    >
      <tbody>
        <tr style={{ height: "14pt" }}>
          <td
            style={{
              width: "61pt",
              borderTopStyle: "solid",
              borderTopWidth: "1pt",
              borderLeftStyle: "solid",
              borderLeftWidth: "1pt",
              borderBottomStyle: "solid",
              borderBottomWidth: "1pt",
              borderRightStyle: "solid",
              borderRightWidth: "1pt",color: "#fff"
            }}
            bgcolor="#001641"
          >
            <p
              className="s23"
              style={{
                paddingTop: "2pt",
                paddingLeft: "4pt",
                textIndent: "0pt",
                textAlign: "left",color: "#fff"
              }}
            >
              Risk Capacity
            </p>
          </td>
          <td
            style={{
              width: "154pt",
              borderTopStyle: "solid",
              borderTopWidth: "1pt",
              borderLeftStyle: "solid",
              borderLeftWidth: "1pt",
              borderBottomStyle: "solid",
              borderBottomWidth: "1pt",
              borderRightStyle: "solid",
              borderRightWidth: "1pt"
            }}
            bgcolor="#001641"
          >
            <p
              className="s23"
              style={{
                paddingTop: "2pt",
                paddingLeft: "4pt",
                textIndent: "0pt",
                textAlign: "left",color: "#fff"
              }}
            >
              Low
            </p>
          </td>
          <td
            style={{
              width: "154pt",
              borderTopStyle: "solid",
              borderTopWidth: "1pt",
              borderLeftStyle: "solid",
              borderLeftWidth: "1pt",
              borderBottomStyle: "solid",
              borderBottomWidth: "1pt",
              borderRightStyle: "solid",
              borderRightWidth: "1pt"
            }}
            bgcolor="#001641"
          >
            <p
              className="s23"
              style={{
                paddingTop: "2pt",
                paddingLeft: "4pt",
                textIndent: "0pt",
                textAlign: "left",color: "#fff"
              }}
            >
              Medium
            </p>
          </td>
          <td
            style={{
              width: "154pt",
              borderTopStyle: "solid",
              borderTopWidth: "1pt",
              borderLeftStyle: "solid",
              borderLeftWidth: "1pt",
              borderBottomStyle: "solid",
              borderBottomWidth: "1pt",
              borderRightStyle: "solid",
              borderRightWidth: "1pt"
            }}
            bgcolor="#001641"
          >
            <p
              className="s23"
              style={{
                paddingTop: "2pt",
                paddingLeft: "4pt",
                textIndent: "0pt",
                textAlign: "left",color: "#fff"
              }}
            >
              High
            </p>
          </td>
        </tr>
        <tr style={{ height: "14pt" }}>
          <td
            style={{
              width: "61pt",
              borderTopStyle: "solid",
              borderTopWidth: "1pt",
              borderLeftStyle: "solid",
              borderLeftWidth: "1pt",
              borderBottomStyle: "solid",
              borderBottomWidth: "1pt",
              borderRightStyle: "solid",
              borderRightWidth: "1pt"
            }}
            bgcolor="#00AAE7"
          >
            <p
              className="s23"
              style={{
                paddingTop: "2pt",
                paddingLeft: "4pt",
                textIndent: "0pt",
                textAlign: "left",color: "#fff"
              }}
            >
              Score
            </p>
          </td>
          <td
            style={{
              width: "154pt",
              borderTopStyle: "solid",
              borderTopWidth: "1pt",
              borderLeftStyle: "solid",
              borderLeftWidth: "1pt",
              borderBottomStyle: "solid",
              borderBottomWidth: "1pt",
              borderRightStyle: "solid",
              borderRightWidth: "1pt"
            }}
            bgcolor="#00AAE7"
          >
            <p
              className="s23"
              style={{
                paddingTop: "2pt",
                paddingLeft: "4pt",
                textIndent: "0pt",
                textAlign: "left"
              }}
            >
              2-9
            </p>
          </td>
          <td
            style={{
              width: "154pt",
              borderTopStyle: "solid",
              borderTopWidth: "1pt",
              borderLeftStyle: "solid",
              borderLeftWidth: "1pt",
              borderBottomStyle: "solid",
              borderBottomWidth: "1pt",
              borderRightStyle: "solid",
              borderRightWidth: "1pt"
            }}
            bgcolor="#00AAE7"
          >
            <p
              className="s23"
              style={{
                paddingTop: "2pt",
                paddingLeft: "4pt",
                textIndent: "0pt",
                textAlign: "left"
              }}
            >
              10-17
            </p>
          </td>
          <td
            style={{
              width: "154pt",
              borderTopStyle: "solid",
              borderTopWidth: "1pt",
              borderLeftStyle: "solid",
              borderLeftWidth: "1pt",
              borderBottomStyle: "solid",
              borderBottomWidth: "1pt",
              borderRightStyle: "solid",
              borderRightWidth: "1pt"
            }}
            bgcolor="#00AAE7"
          >
            <p
              className="s23"
              style={{
                paddingTop: "2pt",
                paddingLeft: "4pt",
                textIndent: "0pt",
                textAlign: "left"
              }}
            >
              18-24
            </p>
          </td>
        </tr>
        <tr style={{ height: "102pt" }}>
          <td
            style={{
              width: "61pt",
              borderTopStyle: "solid",
              borderTopWidth: "1pt",
              borderLeftStyle: "solid",
              borderLeftWidth: "1pt",
              borderBottomStyle: "solid",
              borderBottomWidth: "1pt",
              borderRightStyle: "solid",
              borderRightWidth: "1pt"
            }}
            bgcolor="#00AAE7"
          >
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
            <p
              className="s23"
              style={{ paddingLeft: "4pt", textIndent: "0pt", textAlign: "left" }}
            >
              Description
            </p>
          </td>
          <td
            style={{
              width: "154pt",
              borderTopStyle: "solid",
              borderTopWidth: "1pt",
              borderLeftStyle: "solid",
              borderLeftWidth: "1pt",
              borderBottomStyle: "solid",
              borderBottomWidth: "1pt",
              borderRightStyle: "solid",
              borderRightWidth: "1pt"
            }}
            bgcolor="#00AAE7"
          >
            <p
              className="s23"
              style={{
                paddingTop: "7pt",
                paddingLeft: "4pt",
                paddingRight: "5pt",
                textIndent: "0pt",
                textAlign: "left"
              }}
            >
              Your risk-taking capacity is Low as your earnings and/ or wealth
              minimally matches your current liabilities and lifestyle and/ or you
              have little time
            </p>
            <p
              className="s23"
              style={{
                paddingLeft: "4pt",
                paddingRight: "5pt",
                textIndent: "0pt",
                textAlign: "left"
              }}
            >
              left to retire. In order to achieve your financial goals, you have
              low scope for risky investments, as the capital loss scenario in
              quest of high returns does not match your risk capacity.
            </p>
          </td>
          <td
            style={{
              width: "154pt",
              borderTopStyle: "solid",
              borderTopWidth: "1pt",
              borderLeftStyle: "solid",
              borderLeftWidth: "1pt",
              borderBottomStyle: "solid",
              borderBottomWidth: "1pt",
              borderRightStyle: "solid",
              borderRightWidth: "1pt"
            }}
            bgcolor="#00AAE7"
          >
            <p
              className="s23"
              style={{
                paddingTop: "7pt",
                paddingLeft: "4pt",
                paddingRight: "14pt",
                textIndent: "0pt",
                textAlign: "left"
              }}
            >
              Your risk-taking capacity is Medium as either you have a medium
              level of earning and wealth and/ or have little time left to retire;
              any loss on risky
            </p>
            <p
              className="s23"
              style={{ paddingLeft: "4pt", textIndent: "0pt", textAlign: "left" }}
            >
              investments may have an effect on your current status. Therefore,
              you have the capacity to take low to medium risks
            </p>
            <p
              className="s23"
              style={{ paddingLeft: "4pt", textIndent: "0pt", textAlign: "left" }}
            >
              on your investments for low to medium returns or losses.
            </p>
          </td>
          <td
            style={{
              width: "154pt",
              borderTopStyle: "solid",
              borderTopWidth: "1pt",
              borderLeftStyle: "solid",
              borderLeftWidth: "1pt",
              borderBottomStyle: "solid",
              borderBottomWidth: "1pt",
              borderRightStyle: "solid",
              borderRightWidth: "1pt"
            }}
            bgcolor="#00AAE7"
          >
            <p
              className="s23"
              style={{
                paddingTop: "7pt",
                paddingLeft: "4pt",
                textIndent: "0pt",
                textAlign: "left"
              }}
            >
              Your risk-taking capacity is High due to your earnings/ wealth and
              the financial goals and/ or time available to fulfill them. You may
              withstand losses on risky investments without a very significant
              effect on your current status. Therefore, you have capacity to take
              high risks
            </p>
            <p
              className="s23"
              style={{ paddingLeft: "4pt", textIndent: "0pt", textAlign: "left" }}
            >
              on your investments for equally high returns or losses.
            </p>
          </td>
        </tr>
      </tbody>
    </table>
    <p style={{ paddingTop: "1pt", textIndent: "0pt", textAlign: "left" }}>
      <br />
    </p>
    <table
      style={{ borderCollapse: "collapse", marginLeft: "12.25pt" }}
      cellSpacing={0}
    >
      <tbody>
        <tr style={{ height: "23pt" }}>
          <td
            style={{
              width: "61pt",
              borderTopStyle: "solid",
              borderTopWidth: "1pt",
              borderLeftStyle: "solid",
              borderLeftWidth: "1pt",
              borderBottomStyle: "solid",
              borderBottomWidth: "1pt",
              borderRightStyle: "solid",
              borderRightWidth: "1pt"
            }}
            bgcolor="#001641"
          >
            <p
              className="s23"
              style={{
                paddingTop: "2pt",
                paddingLeft: "4pt",
                paddingRight: "7pt",
                textIndent: "0pt",
                textAlign: "left",
                color: "#fff"
              }}
            >
              Risk Tolerance
            </p>
          </td>
          <td
            style={{
              width: "154pt",
              borderTopStyle: "solid",
              borderTopWidth: "1pt",
              borderLeftStyle: "solid",
              borderLeftWidth: "1pt",
              borderBottomStyle: "solid",
              borderBottomWidth: "1pt",
              borderRightStyle: "solid",
              borderRightWidth: "1pt",
              color: "#fff"
            }}
            bgcolor="#001641"
          >
            <p
              className="s23"
              style={{
                paddingTop: "6pt",
                paddingLeft: "4pt",
                textIndent: "0pt",
                textAlign: "left",color: "#fff"
              }}
            >
              Conservative
            </p>
          </td>
          <td
            style={{
              width: "153pt",
              borderTopStyle: "solid",
              borderTopWidth: "1pt",
              borderLeftStyle: "solid",
              borderLeftWidth: "1pt",
              borderBottomStyle: "solid",
              borderBottomWidth: "1pt",
              borderRightStyle: "solid",
              borderRightWidth: "1pt",color: "#fff"
            }}
            bgcolor="#001641"
          >
            <p
              className="s23"
              style={{
                paddingTop: "6pt",
                paddingLeft: "4pt",
                textIndent: "0pt",
                textAlign: "left",color: "#fff"
              }}
            >
              Moderate
            </p>
          </td>
          <td
            style={{
              width: "155pt",
              borderTopStyle: "solid",
              borderTopWidth: "1pt",
              borderLeftStyle: "solid",
              borderLeftWidth: "1pt",
              borderBottomStyle: "solid",
              borderBottomWidth: "1pt",
              borderRightStyle: "solid",
              borderRightWidth: "1pt",color: "#fff"
            }}
            bgcolor="#001641"
          >
            <p
              className="s23"
              style={{
                paddingTop: "6pt",
                paddingLeft: "4pt",
                textIndent: "0pt",
                textAlign: "left",color: "#fff"
              }}
            >
              Aggressive
            </p>
          </td>
        </tr>
        <tr style={{ height: "14pt" }}>
          <td
            style={{
              width: "61pt",
              borderTopStyle: "solid",
              borderTopWidth: "1pt",
              borderLeftStyle: "solid",
              borderLeftWidth: "1pt",
              borderBottomStyle: "solid",
              borderBottomWidth: "1pt",
              borderRightStyle: "solid",
              borderRightWidth: "1pt"
            }}
            bgcolor="#00AAE7"
          >
            <p
              className="s23"
              style={{
                paddingTop: "2pt",
                paddingLeft: "3pt",
                textIndent: "0pt",
                textAlign: "left"
              }}
            >
              Score
            </p>
          </td>
          <td
            style={{
              width: "154pt",
              borderTopStyle: "solid",
              borderTopWidth: "1pt",
              borderLeftStyle: "solid",
              borderLeftWidth: "1pt",
              borderBottomStyle: "solid",
              borderBottomWidth: "1pt",
              borderRightStyle: "solid",
              borderRightWidth: "1pt"
            }}
            bgcolor="#00AAE7"
          >
            <p
              className="s23"
              style={{
                paddingTop: "2pt",
                paddingLeft: "4pt",
                textIndent: "0pt",
                textAlign: "left"
              }}
            >
              3-7
            </p>
          </td>
          <td
            style={{
              width: "153pt",
              borderTopStyle: "solid",
              borderTopWidth: "1pt",
              borderLeftStyle: "solid",
              borderLeftWidth: "1pt",
              borderBottomStyle: "solid",
              borderBottomWidth: "1pt",
              borderRightStyle: "solid",
              borderRightWidth: "1pt"
            }}
            bgcolor="#00AAE7"
          >
            <p
              className="s23"
              style={{
                paddingTop: "2pt",
                paddingLeft: "4pt",
                textIndent: "0pt",
                textAlign: "left"
              }}
            >
              8-14
            </p>
          </td>
          <td
            style={{
              width: "155pt",
              borderTopStyle: "solid",
              borderTopWidth: "1pt",
              borderLeftStyle: "solid",
              borderLeftWidth: "1pt",
              borderBottomStyle: "solid",
              borderBottomWidth: "1pt",
              borderRightStyle: "solid",
              borderRightWidth: "1pt"
            }}
            bgcolor="#00AAE7"
          >
            <p
              className="s23"
              style={{
                paddingTop: "2pt",
                paddingLeft: "4pt",
                textIndent: "0pt",
                textAlign: "left"
              }}
            >
              15-21
            </p>
          </td>
        </tr>
        <tr style={{ height: "81pt" }}>
          <td
            style={{
              width: "61pt",
              borderTopStyle: "solid",
              borderTopWidth: "1pt",
              borderLeftStyle: "solid",
              borderLeftWidth: "1pt",
              borderBottomStyle: "solid",
              borderBottomWidth: "1pt",
              borderRightStyle: "solid",
              borderRightWidth: "1pt"
            }}
            bgcolor="#00AAE7"
          >
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
            <p
              className="s23"
              style={{ paddingLeft: "3pt", textIndent: "0pt", textAlign: "left" }}
            >
              Description
            </p>
          </td>
          <td
            style={{
              width: "154pt",
              borderTopStyle: "solid",
              borderTopWidth: "1pt",
              borderLeftStyle: "solid",
              borderLeftWidth: "1pt",
              borderBottomStyle: "solid",
              borderBottomWidth: "1pt",
              borderRightStyle: "solid",
              borderRightWidth: "1pt"
            }}
            bgcolor="#00AAE7"
          >
            <p
              style={{ paddingTop: "2pt", textIndent: "0pt", textAlign: "left" }}
            >
              <br />
            </p>
            <p
              className="s23"
              style={{
                paddingLeft: "4pt",
                paddingRight: "5pt",
                textIndent: "0pt",
                textAlign: "left"
              }}
            >
              You are a Conservative investor. Risk should be low, and you are
              prepared to accept lower returns to protect capital. The negative
              effects of inflation may not concern you, provided your initial
              investment is protected.
            </p>
          </td>
          <td
            style={{
              width: "153pt",
              borderTopStyle: "solid",
              borderTopWidth: "1pt",
              borderLeftStyle: "solid",
              borderLeftWidth: "1pt",
              borderBottomStyle: "solid",
              borderBottomWidth: "1pt",
              borderRightStyle: "solid",
              borderRightWidth: "1pt"
            }}
            bgcolor="#00AAE7"
          >
            <p
              className="s23"
              style={{
                paddingTop: "6pt",
                paddingLeft: "4pt",
                paddingRight: "4pt",
                textIndent: "0pt",
                textAlign: "left"
              }}
            >
              You are a Balanced investor who wants a diversified portfolio to
              work towards medium to long-term financial goals. You require an
              Investment strategy that may cope with the effects of inflation.
              Calculated risks may be acceptable to you to achieve good returns.
            </p>
          </td>
          <td
            style={{
              width: "155pt",
              borderTopStyle: "solid",
              borderTopWidth: "1pt",
              borderLeftStyle: "solid",
              borderLeftWidth: "1pt",
              borderBottomStyle: "solid",
              borderBottomWidth: "1pt",
              borderRightStyle: "solid",
              borderRightWidth: "1pt"
            }}
            bgcolor="#00AAE7"
          >
            <p
              style={{ paddingTop: "2pt", textIndent: "0pt", textAlign: "left" }}
            >
              <br />
            </p>
            <p
              className="s23"
              style={{
                paddingLeft: "4pt",
                paddingRight: "8pt",
                textIndent: "0pt",
                textAlign: "left"
              }}
            >
              You are an Aggressive investor prepared to compromise portfolio
              balance to pursue potentially greater long-term returns. Security of
              capital is secondary to the potential for wealth accumulation.
            </p>
          </td>
        </tr>
      </tbody>
    </table>
    <p
      className="s22"
      style={{
        paddingTop: "1pt",
        paddingLeft: "12pt",
        textIndent: "0pt",
        textAlign: "left"
      }}
    >
      Overall  Risk  Profile  Scoring
      and  Classification
      
    </p>
    <p
      style={{
        paddingTop: "8pt",
        paddingLeft: "12pt",
        textIndent: "0pt",
        textAlign: "justify"
      }}
    >
      The following table gives you a brief description of each Risk Profile along
      with the Recommended Asset allocation and a list of suitable products.
    </p>
    <p style={{ textIndent: "0pt", textAlign: "left" }}>
      <br />
    </p>
    <table
      style={{ borderCollapse: "collapse", marginLeft: "12.25pt" }}
      cellSpacing={0}
    >
      <tbody>
        <tr style={{ height: "14pt" }}>
          <td
            style={{
              width: "87pt",
              borderTopStyle: "solid",
              borderTopWidth: "1pt",
              borderLeftStyle: "solid",
              borderLeftWidth: "1pt",
              borderBottomStyle: "solid",
              borderBottomWidth: "1pt",
              borderRightStyle: "solid",
              borderRightWidth: "1pt"
            }}
          >
            <p
              className="s9"
              style={{
                paddingTop: "2pt",
                paddingLeft: "4pt",
                textIndent: "0pt",
                textAlign: "left"
              }}
            >
              Profile
            </p>
          </td>
          <td
            style={{
              width: "87pt",
              borderTopStyle: "solid",
              borderTopWidth: "1pt",
              borderLeftStyle: "solid",
              borderLeftWidth: "1pt",
              borderBottomStyle: "solid",
              borderBottomWidth: "1pt",
              borderRightStyle: "solid",
              borderRightWidth: "1pt"
            }}
            colSpan={3}
            bgcolor="#00AAE7"
          >
            <p
              className="s9"
              style={{
                paddingTop: "2pt",
                paddingLeft: "3pt",
                textIndent: "0pt",
                textAlign: "left"
              }}
            >
              Very conservative
            </p>
          </td>
          <td
            style={{
              width: "87pt",
              borderTopStyle: "solid",
              borderTopWidth: "1pt",
              borderLeftStyle: "solid",
              borderLeftWidth: "1pt",
              borderBottomStyle: "solid",
              borderBottomWidth: "1pt",
              borderRightStyle: "solid",
              borderRightWidth: "1pt"
            }}
            colSpan={2}
            bgcolor="#4EC5D8"
          >
            <p
              className="s9"
              style={{
                paddingTop: "2pt",
                paddingLeft: "3pt",
                textIndent: "0pt",
                textAlign: "left"
              }}
            >
              Conservative
            </p>
          </td>
          <td
            style={{
              width: "88pt",
              borderTopStyle: "solid",
              borderTopWidth: "1pt",
              borderLeftStyle: "solid",
              borderLeftWidth: "1pt",
              borderBottomStyle: "solid",
              borderBottomWidth: "1pt",
              borderRightStyle: "solid",
              borderRightWidth: "1pt"
            }}
            colSpan={3}
            bgcolor="#FFB71B"
          >
            <p
              className="s9"
              style={{
                paddingTop: "2pt",
                paddingLeft: "3pt",
                textIndent: "0pt",
                textAlign: "left"
              }}
            >
              Moderate
            </p>
          </td>
          <td
            style={{
              width: "87pt",
              borderTopStyle: "solid",
              borderTopWidth: "1pt",
              borderLeftStyle: "solid",
              borderLeftWidth: "1pt",
              borderBottomStyle: "solid",
              borderBottomWidth: "1pt",
              borderRightStyle: "solid",
              borderRightWidth: "1pt"
            }}
            colSpan={2}
            bgcolor="#FDD1B0"
          >
            <p
              className="s9"
              style={{
                paddingTop: "2pt",
                paddingLeft: "3pt",
                textIndent: "0pt",
                textAlign: "left"
              }}
            >
              Aggressive
            </p>
          </td>
          <td
            style={{
              width: "87pt",
              borderTopStyle: "solid",
              borderTopWidth: "1pt",
              borderLeftStyle: "solid",
              borderLeftWidth: "1pt",
              borderBottomStyle: "solid",
              borderBottomWidth: "1pt",
              borderRightStyle: "solid",
              borderRightWidth: "1pt"
            }}
            colSpan={3}
            bgcolor="#F47721"
          >
            <p
              className="s9"
              style={{
                paddingTop: "2pt",
                paddingLeft: "3pt",
                textIndent: "0pt",
                textAlign: "left"
              }}
            >
              Very Aggressive
            </p>
          </td>
        </tr>
        <tr style={{ height: "14pt" }}>
          <td
            style={{
              width: "87pt",
              borderTopStyle: "solid",
              borderTopWidth: "1pt",
              borderLeftStyle: "solid",
              borderLeftWidth: "1pt",
              borderBottomStyle: "solid",
              borderBottomWidth: "1pt",
              borderRightStyle: "solid",
              borderRightWidth: "1pt"
            }}
          >
            <p
              className="s9"
              style={{
                paddingTop: "2pt",
                paddingLeft: "4pt",
                textIndent: "0pt",
                textAlign: "left"
              }}
            >
              Score
            </p>
          </td>
          <td
            style={{
              width: "87pt",
              borderTopStyle: "solid",
              borderTopWidth: "1pt",
              borderLeftStyle: "solid",
              borderLeftWidth: "1pt",
              borderBottomStyle: "solid",
              borderBottomWidth: "1pt",
              borderRightStyle: "solid",
              borderRightWidth: "1pt"
            }}
            colSpan={3}
          >
            <p
              className="s9"
              style={{
                paddingTop: "2pt",
                paddingLeft: "4pt",
                textIndent: "0pt",
                textAlign: "left"
              }}
            >
              5 - 11
            </p>
          </td>
          <td
            style={{
              width: "87pt",
              borderTopStyle: "solid",
              borderTopWidth: "1pt",
              borderLeftStyle: "solid",
              borderLeftWidth: "1pt",
              borderBottomStyle: "solid",
              borderBottomWidth: "1pt",
              borderRightStyle: "solid",
              borderRightWidth: "1pt"
            }}
            colSpan={2}
          >
            <p
              className="s9"
              style={{
                paddingTop: "2pt",
                paddingLeft: "3pt",
                textIndent: "0pt",
                textAlign: "left"
              }}
            >
              12 - 19
            </p>
          </td>
          <td
            style={{
              width: "88pt",
              borderTopStyle: "solid",
              borderTopWidth: "1pt",
              borderLeftStyle: "solid",
              borderLeftWidth: "1pt",
              borderBottomStyle: "solid",
              borderBottomWidth: "1pt",
              borderRightStyle: "solid",
              borderRightWidth: "1pt"
            }}
            colSpan={3}
          >
            <p
              className="s9"
              style={{
                paddingTop: "2pt",
                paddingLeft: "3pt",
                textIndent: "0pt",
                textAlign: "left"
              }}
            >
              20 - 28
            </p>
          </td>
          <td
            style={{
              width: "87pt",
              borderTopStyle: "solid",
              borderTopWidth: "1pt",
              borderLeftStyle: "solid",
              borderLeftWidth: "1pt",
              borderBottomStyle: "solid",
              borderBottomWidth: "1pt",
              borderRightStyle: "solid",
              borderRightWidth: "1pt"
            }}
            colSpan={2}
          >
            <p
              className="s9"
              style={{
                paddingTop: "2pt",
                paddingLeft: "3pt",
                textIndent: "0pt",
                textAlign: "left"
              }}
            >
              29 - 36
            </p>
          </td>
          <td
            style={{
              width: "87pt",
              borderTopStyle: "solid",
              borderTopWidth: "1pt",
              borderLeftStyle: "solid",
              borderLeftWidth: "1pt",
              borderBottomStyle: "solid",
              borderBottomWidth: "1pt",
              borderRightStyle: "solid",
              borderRightWidth: "1pt"
            }}
            colSpan={3}
          >
            <p
              className="s9"
              style={{
                paddingTop: "2pt",
                paddingLeft: "3pt",
                textIndent: "0pt",
                textAlign: "left"
              }}
            >
              37 - 45
            </p>
          </td>
        </tr>
        <tr style={{ height: "110pt" }}>
          <td
            style={{
              width: "87pt",
              borderTopStyle: "solid",
              borderTopWidth: "1pt",
              borderLeftStyle: "solid",
              borderLeftWidth: "1pt",
              borderBottomStyle: "solid",
              borderBottomWidth: "1pt",
              borderRightStyle: "solid",
              borderRightWidth: "1pt"
            }}
          >
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
            <p
              className="s9"
              style={{ paddingLeft: "4pt", textIndent: "0pt", textAlign: "left" }}
            >
              Risk Description
            </p>
          </td>
          <td
            style={{
              width: "87pt",
              borderTopStyle: "solid",
              borderTopWidth: "1pt",
              borderLeftStyle: "solid",
              borderLeftWidth: "1pt",
              borderBottomStyle: "solid",
              borderBottomWidth: "1pt",
              borderRightStyle: "solid",
              borderRightWidth: "1pt"
            }}
            colSpan={3}
          >
            <ul id="l12">
              <li data-list-text="—">
                <p
                  className="s9"
                  style={{
                    paddingLeft: "15pt",
                    paddingRight: "27pt",
                    textIndent: "-11pt",
                    textAlign: "left"
                  }}
                >
                  - Low earning expectation
                </p>
              </li>
              <li data-list-text="—">
                <p
                  className="s9"
                  style={{
                    paddingLeft: "15pt",
                    paddingRight: "11pt",
                    textIndent: "-11pt",
                    textAlign: "left"
                  }}
                >
                  - No investments with heightened risk
                </p>
              </li>
              <li data-list-text="—">
                <p
                  className="s9"
                  style={{
                    paddingLeft: "15pt",
                    paddingRight: "4pt",
                    textIndent: "-11pt",
                    textAlign: "left"
                  }}
                >
                  - Very little willingness to lose capital
                </p>
              </li>
            </ul>
          </td>
          <td
            style={{
              width: "87pt",
              borderTopStyle: "solid",
              borderTopWidth: "1pt",
              borderLeftStyle: "solid",
              borderLeftWidth: "1pt",
              borderBottomStyle: "solid",
              borderBottomWidth: "1pt",
              borderRightStyle: "solid",
              borderRightWidth: "1pt"
            }}
            colSpan={2}
          >
            <ul id="l13">
              <li data-list-text="—">
                <p
                  className="s9"
                  style={{
                    paddingLeft: "15pt",
                    paddingRight: "18pt",
                    textIndent: "-11pt",
                    textAlign: "justify"
                  }}
                >
                  - Seeking stable earnings
                </p>
              </li>
              <li data-list-text="—">
                <p
                  className="s9"
                  style={{
                    paddingLeft: "14pt",
                    textIndent: "-10pt",
                  }}
                >
                  - Partial investments with heightened risks possible
                </p>
                
              </li>
              <li data-list-text="—">
                <p
                  className="s9"
                  style={{
                    paddingLeft: "15pt",
                    paddingRight: "11pt",
                    textIndent: "-11pt",
                    textAlign: "justify"
                  }}
                >
                  - Little willingness to suffer losses
                </p>
              </li>
            </ul>
          </td>
          <td
            style={{
              width: "88pt",
              borderTopStyle: "solid",
              borderTopWidth: "1pt",
              borderLeftStyle: "solid",
              borderLeftWidth: "1pt",
              borderBottomStyle: "solid",
              borderBottomWidth: "1pt",
              borderRightStyle: "solid",
              borderRightWidth: "1pt"
            }}
            colSpan={3}
          >
            <ul id="l14">
              <li data-list-text="—">
                <p
                  className="s9"
                  style={{
                    paddingLeft: "15pt",
                    paddingRight: "9pt",
                    textIndent: "-11pt",
                    textAlign: "left"
                  }}
                >
                  - Seeking earnings above market average
                </p>
              </li>
              <li data-list-text="—">
                <p
                  className="s9"
                  style={{
                    paddingLeft: "15pt",
                    paddingRight: "6pt",
                    textIndent: "-11pt",
                    textAlign: "left"
                  }}
                >
                  - Mixture of investments with low and high risks
                </p>
              </li>
              <li data-list-text="—">
                <p
                  className="s9"
                  style={{
                    paddingLeft: "15pt",
                    paddingRight: "4pt",
                    textIndent: "-11pt",
                    textAlign: "left"
                  }}
                >
                  - Willingness to take risks
                </p>
              </li>
            </ul>
          </td>
          <td
            style={{
              borderTopStyle: "solid",
              borderTopWidth: "1pt",
              borderLeftStyle: "solid",
              borderLeftWidth: "1pt",
              borderBottomStyle: "solid",
              borderBottomWidth: "1pt",
              borderRightStyle: "solid",
              borderRightWidth: "1pt"
            }}
            colSpan={2}
          >
            <ul id="l15">
              <li data-list-text="—">
                <p
                  className="s9"
                  style={{
                    paddingLeft: "15pt",
                    paddingRight: "17pt",
                    textIndent: "-11pt",
                    textAlign: "left"
                  }}
                >
                  - Seeking higher earnings
                </p>
              </li>
              <li data-list-text="—">
                <p
                  className="s9"
                  style={{
                    paddingLeft: "15pt",
                    paddingRight: "5pt",
                    textIndent: "-11pt",
                    textAlign: "left"
                  }}
                >
                  - Large investments with heightened risk
                </p>
              </li>
              <li data-list-text="—">
                <p
                  className="s9"
                  style={{
                    paddingLeft: "15pt",
                    paddingRight: "4pt",
                    textIndent: "-11pt",
                    textAlign: "left"
                  }}
                >
                  - Increased willingness to take higher risks
                </p>
              </li>
            </ul>
          </td>
          <td
            style={{
              borderTopStyle: "solid",
              borderTopWidth: "1pt",
              borderLeftStyle: "solid",
              borderLeftWidth: "1pt",
              borderBottomStyle: "solid",
              borderBottomWidth: "1pt",
              borderRightStyle: "solid",
              borderRightWidth: "1pt"
            }}
            colSpan={3}
          >
            <ul id="l16">
              <li data-list-text="—">
                <p
                  className="s9"
                  style={{
                    paddingLeft: "15pt",
                    paddingRight: "18pt",
                    textIndent: "-11pt",
                    textAlign: "left"
                  }}
                >
                  - Seeking higher earnings
                </p>
              </li>
              <li data-list-text="—">
                <p
                  className="s9"
                  style={{
                    paddingLeft: "15pt",
                    paddingRight: "9pt",
                    textIndent: "-11pt",
                    textAlign: "left"
                  }}
                >
                  - Exclusive investments with heightened risk
                </p>
              </li>
              <li data-list-text="—">
                <p
                  className="s9"
                  style={{
                    paddingLeft: "15pt",
                    paddingRight: "12pt",
                    textIndent: "-11pt",
                    textAlign: "left"
                  }}
                >
                  - High willingness to take risks
                </p>
              </li>
            </ul>
          </td>
        </tr>
        <tr style={{ height: "24pt" }}>
          <td
            style={{
              borderTopStyle: "solid",
              borderTopWidth: "1pt",
              borderLeftStyle: "solid",
              borderLeftWidth: "1pt",
              borderRightStyle: "solid",
              borderRightWidth: "1pt"
            }}
          >
          </td>
          <td
            style={{
              borderTopStyle: "solid",
              borderTopWidth: "1pt",
              borderLeftStyle: "solid",
              borderLeftWidth: "1pt",
              borderRightStyle: "solid",
              borderRightWidth: "1pt"
            }}
            colSpan={3}
          >
            <p style={{ textIndent: "0pt", textAlign: "left" }}></p>
            <p
              className="s24"
              style={{
                width:'190px',
                paddingLeft: "10pt",
                paddingRight: "10pt",
                textIndent: "0pt",
                lineHeight: "6pt",
                textAlign: "left"
              }}
            >
              <PieChart
                data={[
                  { title: 'Liquid (20%)', value: 20, color: '#67c23a' },
                  { title: 'Debt (75%)', value: 75, color: '#05aae6' },
                  { title: 'Alternatives (5%)', value: 5, color: '#ffb71b' },
                ]}
                // radius={100}
                // segmentsShift={(index) => (index === 0 ? 7 : 0.5)}
                // label={({ dataEntry }) => dataEntry.value}
                // label={props => { return props.data[props.dataIndex].label;}}
                label={(props) => { return `${props.dataEntry.value}%`;}}
                labelStyle={{
                  ...defaultLabelStyle,
                }}
                // labelPosition={60}
              />              
            </p>
          </td>
          <td
            style={{
              width: "87pt",
              borderTopStyle: "solid",
              borderTopWidth: "1pt",
              borderLeftStyle: "solid",
              borderLeftWidth: "1pt",
              borderRightStyle: "solid",
              borderRightWidth: "1pt"
            }}
            colSpan={2}
          >
            <p
              className="s25"
              style={{
                width:'190px',
                paddingLeft: "10pt",
                paddingRight: "10pt",
                textIndent: "0pt",
                textAlign: "center"
              }}
            >
              <PieChart
                data={[
                  { title: 'Liquid (10%)', value: 10, color: '#67c23a' },
                  { title: 'Debt (50%)', value: 50, color: '#05aae6' },
                  { title: 'Alternatives (15%)', value: 15, color: '#ffb71b' },
                  { title: 'Equity (25%)', value: 25, color: '#f47721' },
                ]}
                label={(props) => { return `${props.dataEntry.value}%`;}}
                labelStyle={{
                  ...defaultLabelStyle,
                }}
              />  
            </p>
          </td>
          <td
            style={{
              width: "88pt",
              borderTopStyle: "solid",
              borderTopWidth: "1pt",
              borderLeftStyle: "solid",
              borderLeftWidth: "1pt",
              borderRightStyle: "solid",
              borderRightWidth: "1pt"
            }}
            colSpan={3}
          >
            <p
              className="s25"
              style={{
                width:'190px',
                paddingLeft: "10pt",
                paddingRight: "10pt",
                textIndent: "0pt",
                textAlign: "center"
              }}
            >
              <PieChart
                data={[
                  { title: 'Liquid (10%)', value: 10, color: '#67c23a' },
                  { title: 'Debt (30%)', value: 30, color: '#05aae6' },
                  { title: 'Alternatives (15%)', value: 15, color: '#ffb71b' },
                  { title: 'Equity (45%)', value: 45, color: '#f47721' },
                ]}
                label={(props) => { return `${props.dataEntry.value}%`;}}
                labelStyle={{
                  ...defaultLabelStyle,
                }}
              />  
            </p>
          </td>
          <td
            style={{
              width: "87pt",
              borderTopStyle: "solid",
              borderTopWidth: "1pt",
              borderLeftStyle: "solid",
              borderLeftWidth: "1pt",
              borderRightStyle: "solid",
              borderRightWidth: "1pt"
            }}
            colSpan={2}
          >
            <p
              className="s25"
              style={{
                width:'190px',
                paddingLeft: "10pt",
                paddingRight: "10pt",
                textIndent: "0pt",
                textAlign: "left"
              }}
            >
              <PieChart
                animation
                animationDuration={500}
                animationEasing="ease-out"
                center={[50, 50]}
                labelPosition={50}
                lengthAngle={360}
                // lineWidth={15}
                // rounded
                paddingAngle={0}
                radius={50}
                startAngle={0}
                viewBoxSize={[100, 100]}
                data={[
                  { title: 'Liquid (10%)', value: 10, color: '#67c23a' },
                  { title: 'Debt (10%)', value: 10, color: '#05aae6' },
                  { title: 'Alternatives (15%)', value: 15, color: '#ffb71b' },
                  { title: 'Equity (65%)', value: 65, color: '#f47721' },
                ]}
                label={(props) => { return `${props.dataEntry.value}%`}}
                // label={(props) => { return props.dataEntry.title;}}
                labelStyle={{
                  ...defaultLabelStyle,
                }}
              />  
            </p>
          </td>
          <td
            style={{
              width: "87pt",
              borderTopStyle: "solid",
              borderTopWidth: "1pt",
              borderLeftStyle: "solid",
              borderLeftWidth: "1pt",
              borderRightStyle: "solid",
              borderRightWidth: "1pt"
            }}
            colSpan={3}
          >
            <p
              className="s26"
              style={{
                width:'190px',
                paddingLeft: "10pt",
                paddingRight: "10pt",
                textIndent: "0pt",
                textAlign: "center"
              }}
            >
              <PieChart
                data={[
                  { title: 'Liquid (10%)', value: 10, color: '#67c23a' },
                  { title: 'Alternatives (10%)', value: 10, color: '#ffb71b' },
                  { title: 'Equity (80%)', value: 80, color: '#f47721' },
                ]}
                label={(props) => { return `${props.dataEntry.value}%`;}}
                labelStyle={{
                  ...defaultLabelStyle,
                }}
              /> 
            </p>
          </td>
        </tr>
        <tr style={{ height: "196pt" }}>
          <td
            style={{
              width: "87pt",
              borderTopStyle: "solid",
              borderTopWidth: "1pt",
              borderLeftStyle: "solid",
              borderLeftWidth: "1pt",
              borderBottomStyle: "solid",
              borderBottomWidth: "1pt",
              borderRightStyle: "solid",
              borderRightWidth: "1pt"
            }}
          >
            <p
              className="s9"
              style={{ paddingLeft: "4pt", textIndent: "0pt", textAlign: "left" }}
            >
              Products
            </p>
          </td>
          <td
            style={{
              width: "87pt",
              borderTopStyle: "solid",
              borderTopWidth: "1pt",
              borderLeftStyle: "solid",
              borderLeftWidth: "1pt",
              borderBottomStyle: "solid",
              borderBottomWidth: "1pt",
              borderRightStyle: "solid",
              borderRightWidth: "1pt"
            }}
            colSpan={3}
          >
            <ul id="l17">
              <li data-list-text="—">
                <p
                  className="s9"
                  style={{
                    paddingLeft: "13pt",
                    paddingRight: "18pt",
                    textIndent: "-9pt",
                    textAlign: "left"
                  }}
                >
                  {" "}
                  - Savings/ Fixed Deposits
                </p>
              </li>
              <li data-list-text="—">
                <p
                  className="s9"
                  style={{
                    paddingLeft: "13pt",
                    paddingRight: "5pt",
                    textIndent: "-9pt",
                    textAlign: "left"
                  }}
                >
                  {" "}
                  - Liquid/ Money Market/ Arbitrage/ Debt Mutual Funds
                </p>
              </li>
              <li data-list-text="—">
                <p
                  className="s9"
                  style={{
                    paddingLeft: "14pt",
                    textIndent: "-10pt",
                    textAlign: "left"
                  }}
                >
                  - Bonds
                </p>
              </li>
              <li data-list-text="—">
                <p
                  className="s9"
                  style={{
                    paddingLeft: "14pt",
                    textIndent: "-10pt",
                    textAlign: "left"
                  }}
                >
                  - Gold
                </p>
              </li>
            </ul>
          </td>
          <td
            style={{
              width: "87pt",
              borderTopStyle: "solid",
              borderTopWidth: "1pt",
              borderLeftStyle: "solid",
              borderLeftWidth: "1pt",
              borderBottomStyle: "solid",
              borderBottomWidth: "1pt",
              borderRightStyle: "solid",
              borderRightWidth: "1pt"
            }}
            colSpan={2}
          >
            <ul id="l18">
              <li data-list-text="—">
                <p
                  className="s9"
                  style={{
                    paddingLeft: "13pt",
                    paddingRight: "18pt",
                    textIndent: "-9pt",
                    textAlign: "left"
                  }}
                >
                  {" "}
                  - Savings/ Fixed Deposits
                </p>
              </li>
              <li data-list-text="—">
                <p
                  className="s9"
                  style={{
                    paddingLeft: "13pt",
                    paddingRight: "7pt",
                    textIndent: "-9pt",
                    textAlign: "left"
                  }}
                >
                  {" "}
                  - Liquid/ Money Market/ Arbitrage / Debt/ Equity Mutual Funds
                </p>
                
              </li>
              <li data-list-text="—">
                <p
                  className="s9"
                  style={{
                    paddingLeft: "14pt",
                    textIndent: "-10pt",
                    textAlign: "left"
                  }}
                >
                  - Bonds
                </p>
              </li>
              <li data-list-text="—">
                <p
                  className="s9"
                  style={{
                    paddingLeft: "14pt",
                    textIndent: "-10pt",
                    textAlign: "left"
                  }}
                >
                  - Gold (Commodities)
                </p>
              </li>
            </ul>
            
          </td>
          <td
            style={{
              width: "88pt",
              borderTopStyle: "solid",
              borderTopWidth: "1pt",
              borderLeftStyle: "solid",
              borderLeftWidth: "1pt",
              borderBottomStyle: "solid",
              borderBottomWidth: "1pt",
              borderRightStyle: "solid",
              borderRightWidth: "1pt"
            }}
            colSpan={3}
          >
            <ul id="l19">
              <li data-list-text="—">
                <p
                  className="s9"
                  style={{
                    paddingLeft: "13pt",
                    paddingRight: "19pt",
                    textIndent: "-9pt",
                    textAlign: "left"
                  }}
                >
                  {" "}
                  - Savings/ Fixed Deposits
                </p>
              </li>
              <li data-list-text="—">
                <p
                  className="s9"
                  style={{
                    paddingLeft: "13pt",
                    paddingRight: "8pt",
                    textIndent: "-9pt",
                    textAlign: "left"
                  }}
                >
                  {" "}
                  - Liquid/ Money Market/ Arbitrage  / Debt/ Equity Mutual Funds
                </p>
                
              </li>
              <li data-list-text="—">
                <p
                  className="s9"
                  style={{
                    paddingLeft: "13pt",
                    textIndent: "-10pt",
                    textAlign: "left"
                  }}
                >
                  - Bonds
                </p>
              </li>
              <li data-list-text="—">
                <p
                  className="s9"
                  style={{
                    paddingLeft: "13pt",
                    textIndent: "-10pt",
                    textAlign: "left"
                  }}
                >
                  - Gold (Commodities)
                </p>
                
              </li>
              <li data-list-text="—">
                <p
                  className="s9"
                  style={{
                    paddingLeft: "13pt",
                    paddingRight: "24pt",
                    textIndent: "-9pt",
                    textAlign: "left"
                  }}
                >
                  {" "}
                  - Portfolio Management Services
                </p>
              </li>
              <li data-list-text="—">
                <p
                  className="s9"
                  style={{
                    paddingLeft: "13pt",
                    paddingRight: "33pt",
                    textIndent: "-9pt",
                    textAlign: "left"
                  }}
                >
                  {" "}
                  - Structured Products
                </p>
              </li>
              <li data-list-text="—">
                <p
                  className="s9"
                  style={{
                    paddingLeft: "13pt",
                    paddingRight: "20pt",
                    textIndent: "-9pt",
                    textAlign: "left"
                  }}
                >
                  {" "}
                  - REIT’s (Rental Yield based products)
                </p>
              </li>
            </ul>
          </td>
          <td
            style={{
              width: "87pt",
              borderTopStyle: "solid",
              borderTopWidth: "1pt",
              borderLeftStyle: "solid",
              borderLeftWidth: "1pt",
              borderBottomStyle: "solid",
              borderBottomWidth: "1pt",
              borderRightStyle: "solid",
              borderRightWidth: "1pt"
            }}
            colSpan={2}
          >
            <ul id="l20">
              <li data-list-text="—">
                <p
                  className="s9"
                  style={{
                    paddingLeft: "13pt",
                    paddingRight: "19pt",
                    textIndent: "-9pt",
                    textAlign: "left"
                  }}
                >
                  {" "}
                  - Savings/ Fixed Deposits
                </p>
              </li>
              <li data-list-text="—">
                <p
                  className="s9"
                  style={{
                    paddingLeft: "13pt",
                    paddingRight: "8pt",
                    textIndent: "-9pt",
                    textAlign: "left"
                  }}
                >
                  {" "}
                  - Liquid/ Money Market/ Arbitrage / Debt/ Equity Mutual Funds
                </p>
                
              </li>
              <li data-list-text="—">
                <p
                  className="s9"
                  style={{
                    paddingLeft: "13pt",
                    textIndent: "-10pt",
                    textAlign: "left"
                  }}
                >
                  - Bonds
                </p>
              </li>
              <li data-list-text="—">
                <p
                  className="s9"
                  style={{
                    paddingLeft: "13pt",
                    textIndent: "-10pt",
                    textAlign: "left"
                  }}
                >
                  - Gold (Commodities)
                </p>
              
              </li>
              <li data-list-text="—">
                <p
                  className="s9"
                  style={{
                    paddingLeft: "13pt",
                    paddingRight: "24pt",
                    textIndent: "-9pt",
                    textAlign: "left"
                  }}
                >
                  {" "}
                  - Portfolio Management Services
                </p>
              </li>
              <li data-list-text="—">
                <p
                  className="s9"
                  style={{
                    paddingLeft: "13pt",
                    paddingRight: "33pt",
                    textIndent: "-9pt",
                    textAlign: "left"
                  }}
                >
                  {" "}
                  - Structured Products
                </p>
              </li>
              <li data-list-text="—">
                <p
                  className="s9"
                  style={{
                    paddingLeft: "13pt",
                    paddingRight: "25pt",
                    textIndent: "-9pt",
                    textAlign: "left"
                  }}
                >
                  {" "}
                  - REIT’s/ Real Estate Funds
                </p>
              </li>
              <li data-list-text="—">
                <p
                  className="s9"
                  style={{
                    paddingLeft: "13pt",
                    paddingRight: "7pt",
                    textIndent: "-9pt",
                    textAlign: "left"
                  }}
                >
                  {" "}
                  - Alternative Investment Funds
                </p>
              </li>
            </ul>
          </td>
          <td
            style={{
              width: "87pt",
              borderTopStyle: "solid",
              borderTopWidth: "1pt",
              borderLeftStyle: "solid",
              borderLeftWidth: "1pt",
              borderBottomStyle: "solid",
              borderBottomWidth: "1pt",
              borderRightStyle: "solid",
              borderRightWidth: "1pt"
            }}
            colSpan={3}
          >
            <ul id="l21">
              <li data-list-text="—">
                <p
                  className="s9"
                  style={{
                    paddingTop: "2pt",
                    paddingLeft: "13pt",
                    paddingRight: "19pt",
                    textIndent: "-9pt",
                    textAlign: "left"
                  }}
                >
                  {" "}
                  - Savings/ Fixed Deposits
                </p>
              </li>
              <li data-list-text="—">
                <p
                  className="s9"
                  style={{
                    paddingLeft: "13pt",
                    paddingRight: "8pt",
                    textIndent: "-9pt",
                    textAlign: "left"
                  }}
                >
                  {" "}
                  - Liquid/ Money Market/ Arbitrage/ Debt/ Equity Mutual Funds
                </p>
                
              </li>
              <li data-list-text="—">
                <p
                  className="s9"
                  style={{
                    paddingLeft: "13pt",
                    textIndent: "-10pt",
                    textAlign: "left"
                  }}
                >
                  - Bonds
                </p>
              </li>
              <li data-list-text="—">
                <p
                  className="s9"
                  style={{
                    paddingLeft: "13pt",
                    textIndent: "-10pt",
                    textAlign: "left"
                  }}
                >
                  - Gold (Commodities)
                </p>
                
              </li>
              <li data-list-text="—">
                <p
                  className="s9"
                  style={{
                    paddingLeft: "13pt",
                    paddingRight: "24pt",
                    textIndent: "-9pt",
                    textAlign: "left"
                  }}
                >
                  {" "}
                  - Portfolio Management Services
                </p>
              </li>
              <li data-list-text="—">
                <p
                  className="s9"
                  style={{
                    paddingLeft: "13pt",
                    paddingRight: "33pt",
                    textIndent: "-9pt",
                    textAlign: "left"
                  }}
                >
                  {" "}
                  - Structured Products
                </p>
              </li>
              <li data-list-text="—">
                <p
                  className="s9"
                  style={{
                    paddingLeft: "13pt",
                    paddingRight: "25pt",
                    textIndent: "-9pt",
                    textAlign: "left"
                  }}
                >
                  {" "}
                  - REIT’s/ Real Estate Funds
                </p>
              </li>
              <li data-list-text="—">
                <p
                  className="s9"
                  style={{
                    paddingLeft: "13pt",
                    paddingRight: "8pt",
                    textIndent: "-9pt",
                    textAlign: "left"
                  }}
                >
                  {" "}
                  - Alternative Investment Funds
                </p>
              </li>
              <li data-list-text="—">
                <p
                  className="s9"
                  style={{
                    paddingLeft: "13pt",
                    paddingRight: "21pt",
                    textIndent: "-9pt",
                    textAlign: "left"
                  }}
                >
                  {" "}
                  - Private Equity Funds
                </p>
              </li>
            </ul>
          </td>
        </tr>

        <tr style={{ height: "16pt" }}>
          <td
            style={{
              width: "87pt",
              borderTopStyle: "solid",
              borderTopWidth: "1pt",
              borderLeftStyle: "solid",
              borderLeftWidth: "1pt",
              borderBottomStyle: "solid",
              borderBottomWidth: "1pt",
              borderRightStyle: "solid",
              borderRightWidth: "1pt"
            }}
          >
            <p
              className="s9"
              style={{
                paddingTop: "3pt",
                paddingLeft: "4pt",
                textIndent: "0pt",
                textAlign: "left"
              }}
            >
              Keys
            </p>
          </td>
          
          
          <td
            colspan="4"
            style={{
              borderTopStyle: "solid",
              borderTopWidth: "1pt",
              borderBottomStyle: "solid",
              borderBottomWidth: "1pt"
            }}
          >
            <p
              className="s28"
              style={{
                paddingTop: "3pt",
                paddingLeft: "1pt",
                textIndent: "0pt",
                textAlign: "left",
                color: "#67c23a"
              }}
            >
              Money Market/ Liquid
            </p>
          </td>
          
          <td
            colspan="3"
            style={{
              width: "36pt",
              borderTopStyle: "solid",
              borderTopWidth: "1pt",
              borderBottomStyle: "solid",
              borderBottomWidth: "1pt"
            }}
          >
            <p
              className="s29"
              style={{
                paddingTop: "3pt",
                paddingLeft: "7pt",
                textIndent: "0pt",
                textAlign: "left",
                color: "#05aae6"
              }}
            >
              Debt
            </p>
          </td>
          
          
          <td
            colspan="3"
            style={{
              width: "36pt",
              borderTopStyle: "solid",
              borderTopWidth: "1pt",
              borderBottomStyle: "solid",
              borderBottomWidth: "1pt"
            }}
          >
            <p
              className="s30"
              style={{
                paddingTop: "3pt",
                paddingLeft: "11pt",
                textIndent: "0pt",
                textAlign: "left",
                color: "#f47721"
              }}
            >
              Equity
            </p>
          </td>
          
          <td
            colspan="3"
            style={{
              width: "66pt",
              borderTopStyle: "solid",
              borderTopWidth: "1pt",
              borderBottomStyle: "solid",
              borderBottomWidth: "1pt"
            }}
          >
            <p
              className="s31"
              style={{
                paddingTop: "3pt",
                paddingLeft: "14pt",
                textIndent: "0pt",
                textAlign: "left",
                color: "#ffb71b"
              }}
            >
              Alternatives
            </p>
          </td>
          
          
        </tr>
      </tbody>
    </table>
    <p style={{ paddingTop: "9pt", textIndent: "0pt", textAlign: "left" }}>
      <br />
    </p>
    <p
      className="s14"
      style={{ paddingLeft: "11pt", textIndent: "0pt", textAlign: "justify" }}
    >
      Money Marche states:
    </p>
    <p
      className="s14"
      style={{ paddingLeft: "11pt", textIndent: "0pt", textAlign: "justify" }}
    >
      This risk profiler is intended for use by the customers as a tool for
      assessing the customer’s risk appetite/ capacity and risk taking ability/
      tolerance. Money Marche AG does not assure the correctness or accuracy of
      the risk assessment by means of the risk profiler. The risk profiler is not
      designed to assure or guarantee any returns or success of any particular
      investment
    </p>
    <p
      className="s14"
      style={{ paddingLeft: "11pt", textIndent: "0pt", textAlign: "justify" }}
    >
      alternative. Neither Money Marche AG nor any members of Money Marche group
      nor other respective directors, officers or employees shall be responsible
      for the contents of the risk profiler or the outcome of risk assessment.
      Investment in securities are subject to market risks. All decisions to sell
      or purchase units/ securities shall be on the basis of own personal judgment
      of the customer after consulting his/ her/ their own external investment
      consultant. Money Marche AG does not in any manner guarantee any returns on
      any of the investment products.
    </p>
  </>


      </form>
    </>
  );
};

export default RiskProfilerForm;
